export default [{
  text: '组件名称',
  name: 'name',
}, {
  name: 'text',
  text: '文本',
  enableVars: true,
  type: 'html',
  language: 'html',
  display: (vm) => {
    const { pageType } = vm.mForm.editor?.editorCore?.page?.value || { pageType: '' };
    return !pageType || pageType?.toLocaleLowerCase().indexOf('hippy') === -1;
  },
}, {
  name: 'text',
  text: '文本',
  display: (vm) => {
    const { pageType } = vm.mForm.editor?.editorCore?.page?.value || { pageType: '' };
    return pageType?.toLocaleLowerCase().indexOf('hippy') > -1;
  },
}, {
  type: 'mod-select',
  modType: 23,
  display: (vm, { model }) => model.text.includes('{{开通获得积分}}') || model.text.includes('{{开通获得V力值}}'),
  name: 'modId',
  text: '开通模块',
}, {
  name: 'multiple',
  text: '多行文本',
  type: 'switch',
  onChange(vm, value, { values }) {
    if (value) {
      // eslint-disable-next-line no-param-reassign
      values.style.height = '100';
    }
  },
}, {
  name: 'style',
  items: [{
    type: 'row',
    span: 8,
    items: [{
      type: 'component',
      id: 'font',
    }],
  }],
  display: (vm) => {
    const { pageType } = vm.mForm.editor?.editorCore?.page?.value || { pageType: '' };
    return pageType?.toLocaleLowerCase().indexOf('hippy') > -1;
  },
}, {
  type: 'component',
  id: 'rect',
}];
